import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
enum FILE_TYPES {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
  AUDIO = "AUDIO",
  UNKNOWN = "UNKNOWN",
}
export default function CreateDropSelectedFilePreview(t0) {
  const $ = _c(21);
  const {
    file
  } = t0;
  const getFileType = _temp;
  const fileType = getFileType(file);
  let t1;
  if ($[0] !== file) {
    t1 = URL.createObjectURL(file);
    $[0] = file;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <img src={t1} alt="" className="tw-w-full tw-h-full tw-object-center tw-object-contain" />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== file) {
    t3 = URL.createObjectURL(file);
    $[4] = file;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== file.type || $[7] !== t3) {
    t4 = <video className="tw-w-full tw-h-full" controls={true}><source src={t3} type={file.type} />Your browser does not support the video tag.</video>;
    $[6] = file.type;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== file) {
    t5 = URL.createObjectURL(file);
    $[9] = file;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== file.type || $[12] !== t5) {
    t6 = <audio className="tw-w-full" controls={true}><source src={t5} type={file.type} />Your browser does not support the audio tag.</audio>;
    $[11] = file.type;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <></>;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t2 || $[16] !== t4 || $[17] !== t6) {
    t8 = {
      [FILE_TYPES.IMAGE]: t2,
      [FILE_TYPES.VIDEO]: t4,
      [FILE_TYPES.AUDIO]: t6,
      [FILE_TYPES.UNKNOWN]: t7
    };
    $[15] = t2;
    $[16] = t4;
    $[17] = t6;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const components = t8;
  const t9 = components[fileType];
  let t10;
  if ($[19] !== t9) {
    t10 = <div className="tw-mt-2 tw-flex tw-gap-x-3"><div className="tw-h-full tw-w-full">{t9}</div></div>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}
function _temp(file_0) {
  if (file_0.type.includes("image")) {
    return FILE_TYPES.IMAGE;
  }
  if (file_0.type.includes("video")) {
    return FILE_TYPES.VIDEO;
  }
  if (file_0.type.includes("audio")) {
    return FILE_TYPES.AUDIO;
  }
  return FILE_TYPES.UNKNOWN;
}